<div class="element-form-container dsforms-element-separator-container no-bottom-pad" qa="separator-element">
    <div class="separator"></div>
</div>
